import React from "react";

export default function MeshIcon(props: any) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="80"
      viewBox="0 0 80 80"
    >
      <g fill="none" fillRule="evenodd">
        <g fill="#231F20">
          <g>
            <g>
              <g>
                <g>
                  <path
                    d="M48 24c0 13.255-10.745 24-24 24S0 37.255 0 24 10.745 0 24 0s24 10.745 24 24M65.884 40c1.334-1.49 2.48-3.148 3.413-4.937h-20.67c-.787 1.752-1.753 3.407-2.881 4.937h20.138zM71.92 22.125c-.132-1.702-.438-3.354-.907-4.937H50.132c.414 1.592.68 3.244.796 4.937H71.92zM69.425 13.188C68.522 11.4 67.403 9.745 66.1 8.25H45.924c1.104 1.534 2.05 3.187 2.817 4.938h20.684zM50.06 31.063h20.882c.487-1.582.81-3.235.96-4.938H50.91c-.132 1.695-.418 3.346-.85 4.938M61.63 4.25C57.76 1.572 53.066 0 48 0c-3.112 0-6.082.599-8.81 1.678 1.136.775 2.209 1.637 3.212 2.572H61.63zM48 48c4.905 0 9.464-1.475 13.265-4H42.138c-.927.841-1.913 1.616-2.95 2.323C41.917 47.402 44.888 48 48 48"
                    transform="translate(-605 -2618) translate(506 2598) translate(51 20) translate(48) translate(4 16)"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
